var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBones(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.64273 23.1615C4.04316 22.6174 3.66329 21.9085 3.54888 21.1469C2.71134 21.0438 1.93024 20.6983 1.32917 20.1535C-0.196415 18.7717 -0.19881 16.5251 1.32917 15.1411C2.6198 13.9725 4.76322 13.7974 6.24459 14.6897L16.3654 5.49881C15.3812 4.15408 15.4986 2.27369 16.8627 1.0369C18.3822 -0.344926 20.8613 -0.346344 22.3868 1.0369C22.9864 1.58107 23.3663 2.28999 23.4807 3.05081C24.3182 3.15464 25.1008 3.50012 25.7004 4.04495C27.226 5.42669 27.2284 7.67331 25.7004 9.05727C24.4113 10.2273 22.2679 10.4031 20.785 9.50866L10.6642 18.6996C11.6484 20.0443 11.5309 21.9247 10.1668 23.1615C8.64458 24.5431 6.16544 24.5436 4.64273 23.1615Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBones);
export default __webpack_public_path__ + "static/media/bones.410ddbd9.svg";
export { ForwardRef as ReactComponent };